import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { translate } from "react-i18next"
import { Modal, ModalHeader, ModalBody } from "reactstrap"
import WidgetHeader from "./WidgetHeader"
import SampleSizeWarning from "./SampleSizeWarning"
import { media } from "../../../utils/style-utils"
import { connect } from "react-redux"
import { compose } from "redux"
import * as helpActions from "../../../state/actions/helpActions"

const CardBody = styled.div`
  padding: 10px !important;
  position: relative;
`

const Card = styled.div`
  margin-bottom: 10px !important;
`

const HelpIconButton = styled.a`
  font-size: 1.1em;
  display: none;
  padding: 5px;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  right: 5px;
  z-index: 100;
  float: none;
  ${media.tablet`cursor: pointer; display: inline!important; position: static!important; float: right!important;`};

  &:hover {
    color: ${props => props.primaryColor} !important;
    cursor: pointer;
  }
`
class Widget extends Component {
  static propTypes = {
    /** Optional identifer */
    id: PropTypes.string,
    appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
    /** The child graph etc */
    children: PropTypes.node.isRequired,
    /** Either 1, 2 or 3 */
    columns: PropTypes.number.isRequired,
    /** The api url to download the export from (without filter params) */
    exportEndpoint: PropTypes.string.isRequired,
    /** The title shown at the top of the widget */
    titleKey: PropTypes.string.isRequired,
    /** The optional subtitle under title */
    subtitleKey: PropTypes.string,
    /** The key for the translation to show in a help tooltip/popup */
    helpKey: PropTypes.string,
    /* Extra parameters to append to export URL */
    exportParams: PropTypes.string,
    t: PropTypes.func.isRequired,
    theme: PropTypes.shape({
      primaryColor: PropTypes.string.isRequired,
      primaryColorHover: PropTypes.string.isRequired,
      navBackgroundColor: PropTypes.string.isRequired
    }).isRequired,
    setHelpIconClicked: PropTypes.func.isRequired,
    sampleSize: PropTypes.object
  }

  static defaultProps = {
    id: null,
    helpKey: null,
    sampleSize: null
  }

  state = {
    hasError: false,
    helpModalDisplayed: false
  }

  componentWillMount = () => {
    // Set the widget width: 1, 2 or 3 thirds
    switch (this.props.columns) {
      case 1:
        this.columnWidth = "4"
        break
      case 2:
        this.columnWidth = "8"
        break
      default:
        this.columnWidth = "12"
    }
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true })
  }

  toggleHelpModal = () => {
    this.props.setHelpIconClicked()
    this.setState({
      helpModalDisplayed: !this.state.helpModalDisplayed
    })
  }

  render() {
    const {
      id,
      exportEndpoint,
      exportParams,
      titleKey,
      subtitleKey,
      children,
      appliedFilters,
      helpKey,
      t,
      helpClicked,
      theme,
      sampleSize
    } = this.props

    return (
      <Fragment>
        <div id={id != null ? id : ""} className={`col-lg-${this.columnWidth} col-md-12`}>
          <Card className="card">
            <CardBody className="card-body">
              {this.state.hasError ? (
                <p>{t("Errors.WidgetFrontendError")}</p>
              ) : (
                <Fragment>
                  <WidgetHeader
                    titleKey={titleKey}
                    appliedFilters={appliedFilters}
                    exportEndpoint={exportEndpoint}
                    exportParams={exportParams}
                    subtitleKey={subtitleKey}
                  />
                  <div className="row">{children}</div>

                  <SampleSizeWarning sampleSize={sampleSize} />
                  {helpKey && (
                    <Fragment>
                      <HelpIconButton
                        onClick={this.toggleHelpModal}
                        className={
                          helpClicked ? "show-on-card-hover" : "show-on-card-hover animated wobble"
                        }
                        title={t("Widget.HelpTooltip")}
                        primaryColor={theme.primaryColor}
                      >
                        <i className="fa fa-info-circle" />
                      </HelpIconButton>
                      <div className="clearfix" />
                    </Fragment>
                  )}
                </Fragment>
              )}
            </CardBody>
          </Card>
        </div>
        {helpKey && (
          <Modal isOpen={this.state.helpModalDisplayed} toggle={this.toggleHelpModal}>
            <ModalHeader toggle={this.toggleHelpModal}>{t(titleKey)}</ModalHeader>
            <ModalBody>
              <div dangerouslySetInnerHTML={{ __html: t(helpKey) }} />
            </ModalBody>
          </Modal>
        )}
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    helpClicked: state.help.helpIsClicked,
    theme: state.userDetail.theme
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setHelpIconClicked: () => dispatch(helpActions.setHelpIconClicked())
  }
}

export default compose(translate(), connect(mapStateToProps, mapDispatchToProps))(Widget)



// WEBPACK FOOTER //
// ./src/components/layout/widget/Widget.jsx